<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="printerMaterials"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="打印机名称">
              <el-input v-model.trim="filter.printerName" placeholder="请输入打印机名称" clearable/>
            </el-form-item>
            <el-form-item label="组件名称">
              <el-input v-model.trim="filter.moduleName" placeholder="请输入组件名称" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <printer-binding-edit ref="printerBindingEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import PrinterBindingEdit from "./PrinterBindingEdit.vue";

  export default {
    name: "PrinterBinding",
    components: { ViewTable, PrinterBindingEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(86),
          editAuth: this.$auth(86),
          delAuth: this.$auth(87),
        },
        filter: {
          printerName: "",
          moduleName: "",
          materialNo: "",
        },
        columnsProperty: [
          {
            tooltip: true,
            key: "printerName",
          },
          {
            tooltip: true,
            key: "materialName",
          },
          {
            key: "moduleName",
            tooltip: true,
            align: "center",
          },
          {
            key: "moduleUrl",
            tooltip: true,
            align: "center",
            title: "组件模板路径",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        this.$refs.printerBindingEdit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "printerMaterials", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
